import pr1Tell1 from '../img/projects/readjourney-tell1@1x.webp';
import pr1Tell2 from '../img/projects/readjourney-tell2@2x.webp';
import pr1Desk1 from '../img/projects/readjourney-tab-desk1@1x.webp';
import pr1Desk2 from '../img/projects/readjourney-tab-desk2@2x.webp';

import pr2Tell1 from '../img/projects/petlove-tell1@1x.webp';
import pr2Tell2 from '../img/projects/petlove-tell2@2x.webp';
import pr2Desk1 from '../img/projects/petlove-tablet-desck1@1x.webp';
import pr2Desk2 from '../img/projects/petlove-tablet-desck2@2x.webp';

import pr3Tell1 from '../img/projects/register-tell1@1x.webp';
import pr3Tell2 from '../img/projects/register-tell2@2x.webp';
import pr3Desk1 from '../img/projects/register-tablet-desck1@1x.webp';
import pr3Desk2 from '../img/projects/register-tablet-desck2@2x.webp';

export default {
  pr1Tell1,
  pr1Tell2,
  pr1Desk1,
  pr1Desk2,
  pr2Tell1,
  pr2Tell2,
  pr2Desk1,
  pr2Desk2,
  pr3Tell1,
  pr3Tell2,
  pr3Desk1,
  pr3Desk2,
};
